import { stringify } from 'qs';
import queryStringSerializer from '@shared/queryStringSerializer';

const stringifyArray = (collection: string[] | string | null): string | null =>
  Array.isArray(collection) ? collection.join(',') : collection;

export default {
  root: '/',
  users: {
    edit: (accountSettingsTab: string) => `/users/account/${accountSettingsTab}`,
  },
  building: (buildingSlug: string) => `/building/${buildingSlug}`,
  buildingPreview: (buildingSlug: string) => `/building_previews/${buildingSlug}`,
  listing: (listingId: string, buildingSlug: string) => `/listing/${buildingSlug}/${listingId}`,
  listingPreview: (listingId: string) => `/listing_previews/${listingId}`,
  listingShare: (encodedData: string) => `/listing_shares/${encodedData}`,
  vtsMarketBuildingShare: (buildingSlug: string) => `/market_buildings/${buildingSlug}`,
  vtsMarketListingShare: (listingId: string) => `/market_listings/${listingId}`,
  officeSpaceWithOneMarket: (
    marketSlug: string,
    { page = null, sort = null, sizes = null, spaceConditions = null } = {},
  ) => {
    const params = {
      page,
      sort,
      size: stringifyArray(sizes),
      space_condition: stringifyArray(spaceConditions),
    };
    const queryString = queryStringSerializer(params);
    return `/office-space/${marketSlug}${queryString ? `?${queryString}` : ''}`;
  },
  listingSearch: ({
    page = null,
    sort = null,
    markets = null,
    sizes = null,
    spaceConditions = null,
    map = null,
  }: {
    page?: number | null;
    markets?: string | null;
    sort?: string | null;
    sizes?: string | null;
    spaceConditions?: string | null;
    map?: string | null;
  } = {}) => {
    const params = {
      page,
      sort,
      size: stringifyArray(sizes),
      markets: stringifyArray(markets),
      space_condition: stringifyArray(spaceConditions),
      map,
    };

    const queryString = queryStringSerializer(params);
    return `/office-space/for-rent${queryString ? `?${queryString}` : ''}`;
  },
  listingSearchForMarket: (marketSlug?: string | null) =>
    `/office-space/${marketSlug || 'for-rent'}`,
  login: '/login',
  vtsMarketLandlordShare: (landlordSlug: string) => `/market_landlords/${landlordSlug}`,
  landlords: (landlordSlug: string) => `/landlords/${landlordSlug}`,
  signUp: (
    vtsUrl: string,
    // eslint-disable-next-line camelcase
    query: { utm_term?: string; utm_content?: string; anonymous_id?: string } = {},
  ) => {
    const queryString = stringify(
      { ...query, source: 'marketplace' },
      { addQueryPrefix: true, skipNulls: true },
    );

    return `${vtsUrl}/users/sign_up${queryString}`;
  },
  savedListings: '/saved/listings',
  savedSearches: '/saved/searches',
  savedBuildings: '/saved/buildings',
  savedBuildingOwners: '/saved/building_owners',
  search: (marketSlug: string) => `/search/${marketSlug}`,
  tourbook: (tourbookId: string) => `/tourbooks/${tourbookId}`,
  tourbookShare: (tourbookId: string) => `/tourbook_shares/${tourbookId}`,
  tourbookNewExternalListing: (tourbookId: string) =>
    `/tourbooks/${tourbookId}/external_listings/new`,
  tourbooks: '/tourbooks',
  tourbookEditExternalListing: (tourbookId: string, externalListingId: string) =>
    `/tourbooks/${tourbookId}/external_listings/${externalListingId}/edit`,
  waitlist: (
    vtsUrl: string,
    // eslint-disable-next-line camelcase
    query: { utm_term?: string; utm_content?: string; anonymous_id?: string } = {},
  ) => {
    const queryString = stringify(
      { ...query, source: 'marketplace' },
      { addQueryPrefix: true, skipNulls: true },
    );

    return `${vtsUrl}/waitlist${queryString}`;
  },
} as const;
